<template>
  <Base
    :onSubmit="(params) => reportsService.createCase(params)"
    :trigerPrevent="trigerPrevent"
    :isQr="false"
  />
</template>

<script>
import Base from './base.vue';

import { ReportsMixin } from '../../../../../mixins';

export default {
  title: 'NewCase',
  components: { Base },
  mixins: [ReportsMixin],
  beforeRouteLeave(to, from, next) {
    if (this.disablePrevent) {
      return next();
    }
    const answer = window.confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  data() {
    return {
      disablePrevent: true,
    };
  },
  methods: {
    trigerPrevent: function (value) {
      this.disablePrevent = value;
    },
  },
};
</script>
